import { FilterSetType } from '@statsbomb/parachute-types';
import { useSetAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import { userConfigActionAtom, userConfigNameAtom, userConfigTypeAtom } from '@/atoms/userConfigs';
import { UserConfigActions } from '@/types/userConfigs';

export const useDuplicateUserSavedFilters = (selectedFilterSetName: string) => {
  const { t } = useTranslation('general');
  const setUserConfigName = useSetAtom(userConfigNameAtom);
  const setUserConfigActions = useSetAtom(userConfigActionAtom);
  const setUserConfigTypeToAmend = useSetAtom(userConfigTypeAtom);

  return () => {
    setUserConfigName(`${selectedFilterSetName} - ${t('copy')}`);
    setUserConfigActions(UserConfigActions.DUPLICATE);
    setUserConfigTypeToAmend(FilterSetType.FILTERS);
  };
};
